<div>
  <div *ngIf="this.error">
    {{ error | json }}
  </div>

  <button type="button" class="btn btn-block btn-primary mb-2" (click)="reloadConfig()" translate>RELOAD_CONFIG</button>
  <button type="button" class="btn btn-block btn-secondary" (click)="restartApp()" translate>RESTART_APP</button>
</div>
